import React from "react"
import { Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const HeroImage = ({ image, title, subText }) => {
  return (
    <BackgroundImage
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
      fluid={image.childImageSharp.fluid}
    >
      <div className="text-center">
        <h1 className="text-center text-white display-4">
          {title}
        </h1>
        <p className="lead text-white">
          {subText} </p>
        <Link to="/contact">
          <button
            type="button"
            className="btn text-white"
            style={{ background: "rgb(178, 146, 78)", cursor: "pointer" }}
          >
            Contact Me Today
          </button>
        </Link>
      </div>
    </BackgroundImage>
  )
}

export default HeroImage
